import { CountBadge, ColorName } from "@void-orbit/ui";

export interface BadgeProps {
  number: number;
  color: ColorName;
};

export const Badge = ({ number, color }: BadgeProps ) => <CountBadge count={ number } color={ color } />;
